import React, { useEffect, useMemo, useState } from "react";
import { IVacanciesData } from "../../exports/interfaces";
import { useMobile } from "../../hooks/custom/useMobile";
import useTab from "../../hooks/custom/useTab";
import { Link } from "react-router-dom";

interface Props {
  adminVacancies: IVacanciesData[];
  academicVacancies: IVacanciesData[];
  selectedVacancies: string;
  setSelectedVacancies: React.Dispatch<React.SetStateAction<string>>;
  openSidebar: boolean;
  setOpenSidebar: React.Dispatch<React.SetStateAction<boolean>>;
}

const VacanciesSidebar = ({
  adminVacancies,
  academicVacancies,
  selectedVacancies,
  setSelectedVacancies,
  openSidebar,
  setOpenSidebar,
}: Props) => {
  const mobile = useMobile();
  const tab = useTab();

  const [openMenu, setOpenMenu] = useState<string[]>([]);
  const [openSubMenu, setOpenSubMenu] = useState<string | null>(null);

  const categories = ["Academic Posts", "Admin Posts"];

  const vacancies = useMemo(
    () => [
      ...academicVacancies.map((item) => ({
        ...item,
        type: "Academic Posts",
      })),
      ...adminVacancies.map((item) => ({
        ...item,
        type: "Admin Posts",
      })),
    ],
    [adminVacancies, academicVacancies],
  );

  useEffect(() => {
    const hash = window.location.hash.replace("#", "").toLowerCase();

    if (hash === "admin") {
      setOpenMenu(["Admin Posts"]);
    } else if (hash === "academic") {
      setOpenMenu(["Academic Posts"]);
    } else {
      setOpenMenu(["Academic Posts", "Admin Posts"]);
    }
  }, []);

  useEffect(() => {
    const matchedProgram = vacancies.find(
      (item) =>
        item.adv_code.toLowerCase() ===
        decodeURIComponent(selectedVacancies).toLowerCase(),
    );

    if (matchedProgram) {
      setOpenSubMenu(matchedProgram.adv_code);
    }
  }, [vacancies, selectedVacancies]);

  return (
    <div
      className={`col-lg-4 sidebar_mobile_wrapper ${
        openSidebar ? "sidebar_mobile_open" : ""
      }`}
    >
      <div className="sidebar_menu">
        {(mobile || tab) && (
          <div className="sidebar_mobile_header">
            <button
              className="sidebar_close_btn"
              onClick={() => setOpenSidebar(false)}
            >
              <i className="fa-solid fa-xmark"></i>
            </button>
          </div>
        )}

        <h2
          className={`${mobile || tab ? "td_fs_36" : "td_fs_48"}`}
          style={
            mobile || tab
              ? {
                  width: "90%",
                }
              : {}
          }
        >
          Vacancy Position
        </h2>

        <div className="sidebar_line" />

        {categories.map((item, index) => {
          const isOpen = openMenu.includes(item);

          return (
            <div key={index} className="sidebar_item">
              <div
                className={`sidebar_heading ${isOpen ? "sidebar_active" : ""}`}
                onClick={() => {
                  setOpenMenu((prev) =>
                    isOpen
                      ? prev.filter((menu) => menu !== item)
                      : [...prev, item],
                  );
                }}
              >
                <div className="sidebar_heading_left">
                  <h6
                    style={
                      mobile || tab
                        ? {
                            width: "90%",
                          }
                        : {}
                    }
                  >
                    {item}
                  </h6>

                  <i
                    className={`fa-solid fa-chevron-down sidebar_icon ${
                      isOpen
                        ? `rotate_icon ${!mobile && "ps-2"}`
                        : `${!mobile && "pe-2"}`
                    }`}
                  />
                </div>
              </div>

              <div className={`sidebar_submenu ${isOpen ? "open" : ""}`}>
                {vacancies
                  .filter((sub) => sub.type === item)
                  .map((sub, i) => {
                    const subOpen = openSubMenu === sub.adv_code;

                    return (
                      <Link
                        key={i}
                        to="/vacancy"
                        className={`sidebar_subitem ${
                          subOpen ? "sidebar_active" : ""
                        }`}
                        onClick={(e) => {
                          e.preventDefault();

                          setOpenSubMenu(sub.adv_code);
                          setSelectedVacancies(sub.adv_code);

                          if (mobile || tab) {
                            setOpenSidebar(false);
                          }
                        }}
                      >
                        <span className="td_fs_20">
                          {sub.adv_code} - {sub.position}
                        </span>
                      </Link>
                    );
                  })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default VacanciesSidebar;
